import type { ColorsDots } from "@/types/utils/Colors";

export const getDotColor = (color: ColorsDots) => {
  // eslint-disable-next-line no-unused-vars
  const colorMap: { [key in ColorsDots]: string } = {
    tangerine: "var(--token-cobasi-colors-tangerine-primary)",
    turquoise: "var(--token-cobasi-colors-turquoise-primary)",
    "pa-blue": "var(--token-pet-anjo-colors-blue-primary)",
    aqua: "var(--token-cobasi-colors-aqua-primary)",
    orange: "var(--token-cobasi-colors-orange-primary)",
    lemon: "var(--token-cobasi-colors-lemon-primary)"
  };

  return colorMap[color] || "var(--token-cobasi-colors-lemon-primary)";
};
